"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Message = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var index_1 = require("../../../index");
function Message() {
    return (react_1.default.createElement(index_1.SettingContainer, null,
        react_1.default.createElement(index_1.DefaultTitle, null, "\u901A\u77E5"),
        react_1.default.createElement(index_1.SelectButtonGroupView, { data: [
                {
                    text: "通知栏目",
                },
            ] },
            react_1.default.createElement(index_1.SwitchButton, null))));
}
exports.Message = Message;
//# sourceMappingURL=Message.js.map